import React from 'react';
import { Alert } from 'react-bootstrap';

export default function SuccessToast({ header, message }) {
    return !!message ? (
        <Alert variant="success">
            <Alert.Heading>
                {header}
            </Alert.Heading>
            {message}
        </Alert>
    ) : null;
}